import React, { memo, useMemo } from 'react';
import Button from '../../../../../shared/components/Button';
import { useTranslation } from 'react-i18next';
import { toast } from '../../../../../shared/helpers/toast';
import { installationAndAssignedStatusesGps } from '../../../../../shared/helpers/constants';


const Form = ({
    submitFetching,
    onClose,
    submitGpsDevicesRequest,
    idGpsDevices,
    name,
    observation,
    assigned,
    enabled,
    status,
    protocol,
    simcard,
    device,
    unlockFetching,
    unlockGpsRequest,
    gps_device
}) => {
    const { t } = useTranslation(['home', 'notification']);
    const gpsDeviceNotExists = useMemo(() => typeof gps_device._id === 'undefined',[gps_device]);

    const gpsWasAsignedOrInstalled = useMemo(() => !gpsDeviceNotExists ? 
        installationAndAssignedStatusesGps.includes(gps_device.status._id)
        :
        installationAndAssignedStatusesGps.includes(status.value)
    ,[status,gpsDeviceNotExists]);
    
    const simcardOrDeviceValueExist = useMemo(() => Array.isArray(gps_device.simcard) || Array.isArray(gps_device.device),[gps_device]);

    
    const handleUnlock = event => {
        event.preventDefault();
        unlockGpsRequest(idGpsDevices);
    }
    const validate = () => {
        let isValid = true;

        if (!name.length) {
            toast(t("notification:choose_name"));
            isValid = false;
        }

        if (simcard.value === null || !simcard.value.length) {
            toast(t("notification:choose_simcard"));
            isValid = false;
        }

        if (device.value === null || !device.value.length) {
            toast(t("notification:choose_device"));
            isValid = false;
        }

        if (!protocol.length) {
            toast(t("notification:enter_protocol"));
            isValid = false;
        }

        if (status.value === null || !status.value.length) {
            toast(t("notification:choose_status"));
            isValid = false;
        }

        return isValid;
    }

    const submit = () => {

        if (!validate()) {
            return false;
        }

        let gps_device = {
            name,
            simcard: simcard.value,
            device: device.value,
            enabled: enabled.value,

        };

        if (idGpsDevices) {
            gps_device._id = idGpsDevices;
        }

        if (assigned.value) {
            gps_device.assigned = assigned.value;
        }

        if (protocol && protocol.length) {
            gps_device.protocol = protocol
        }

        if (observation && observation.length) {
            gps_device.observation = observation;
        }

        if (status.value && status.value.length) {
            gps_device.status = status.value;
        }

        submitGpsDevicesRequest(gps_device);

    }

    return (
        <>
            {!(gpsWasAsignedOrInstalled || gpsDeviceNotExists || simcardOrDeviceValueExist ) && <Button loading={unlockFetching} onClick={handleUnlock}>{t("home:unlock")}</Button>}
            <Button onClick={onClose}>{t("home:cancel")}</Button>
            <Button onClick={submit} loading={submitFetching}>{t("home:submit")}</Button>
        </>
    );
}

export default memo(Form);